export default {
  create: {
    method: 'post',
    url: '/client/partner/task-completion-time/cooperatorId'
  },
  getById: {
    method: 'get',
    url: '/client/partner/task-completion-time/cooperatorId/ID'
  },
  edit: {
    method: 'put',
    url: '/client/partner/task-completion-time/cooperatorId/ID'
  },
  delete: {
    method: 'delete',
    url: '/client/partner/task-completion-time/cooperatorId'
  },
  archive: {
    method: 'delete',
    url: '/client/partner/task-completion-time/archive'
  },
  restore: {
    method: 'put',
    url: '/client/partner/task-completion-time/restore'
  }
}
